// Componente para a aba 7 - Exibição do Workflow do processo.

import React from 'react';
import axios from "axios";

const WorkflowTabAners = ({ id, token, idProcess, responseWorkflow, dataFormato }) => {

  // Funções auxiliares para confirmação do workflow
  function verifyConfirmWorkflow() {
    console.log(responseWorkflow);
    if (responseWorkflow) {
        console.log("Response");
        return null;
    } else {
        console.log("Sem response");
        return (
            <div
                className="col-12 confirm-success text-white"
                id="envio-pagamentos"
                onClick={confirmWorkflow}
            >
                <div className="row center-element">Enviar</div>
            </div>
        );
    }
}

function confirmWorkflow() {
    axios
        .post(
            `/api/confirm/process/${idProcess}`,
            { token },
            {
                withCredentials: true,
            }
        )
        .then((response) => {
            window.location = response.data;
        });
}
  return (
    <div className="tab-pane fade" id={id} role="tabpanel">
      <div className="card-body table-responsive p-0">
        <table className="table table-striped table-bordered mt-10">
          <tbody>
            <tr></tr>
            <tr>
              <th>DATA</th>
              <th>RESPONSÁVEL</th>
              <th>STATUS</th>
            </tr>
            <tr>
              <th>{responseWorkflow ? dataFormato(responseWorkflow.data) : null}</th>
              <th>{responseWorkflow ? responseWorkflow.responsavel : null}</th>
              <th>{responseWorkflow ? responseWorkflow.status : null}</th>
            </tr>
          </tbody>
        </table>
      </div>
      {verifyConfirmWorkflow()}
    </div>
  );
};

export default WorkflowTabAners;
